import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A fill gizmo: a geometry drawn as an unlit translucent `<mesh>` over the scene. Inside a
 * `PluginGizmo` it wears the look of its node, from the every-node gate or `SelectedOnly` (ADR-0056).
 * The caller builds and memoises the geometry.
 */
import { useMemo } from 'react';
import { canvasItemFacing } from '../canvasItemFacing';
import { materialProgramInputs } from '../materialProgramInputs';
import { useDisposeOnRelease } from '../useDisposeOnRelease';
import { useGizmoLook } from '../gizmo/useGizmoLook';
import { GIZMO_RENDER_ORDER, GizmoGroup } from './GizmoGroup';
export function GizmoMesh({ geometry, color: ownColor, alpha: ownAlpha }) {
    const { color, opacity } = useGizmoLook(ownColor, ownAlpha);
    useDisposeOnRelease(geometry);
    // Godot's gizmo material culls no face (`node_3d_editor_gizmos.cpp:927`), so one pass draws both.
    const program = useMemo(() => materialProgramInputs({
        props: { color, opacity, transparent: true, depthWrite: false, fog: false },
        merge: [canvasItemFacing()],
    }), [color, opacity]);
    if (!geometry)
        return null;
    return (_jsx(GizmoGroup, { children: _jsx("mesh", { renderOrder: GIZMO_RENDER_ORDER, geometry: geometry, children: _jsx("meshBasicMaterial", { ...program.props }, program.key) }) }));
}
//# sourceMappingURL=GizmoMesh.js.map